module.exports = __webpack_public_path__ + "static/img/no7.1082636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no7.png
// module id = Rx/t
// module chunks = 31